import CTACard from './CTACard';

export default CTACard;
